import React from 'react';
import moment from 'moment';
import { Input, Tooltip, Select, Checkbox, Button } from 'antd/lib';
import { Form } from '@ant-design/compatible';
import * as Icons from '@ant-design/icons';

import { graphql, compose } from 'react-apollo';

import getOrganismos from '../../../graphql/querys/organismos/getOrganismos.graphql';
import getUsuario from '../../../graphql/querys/auth/getUsuario.graphql';

import * as DeclaracionRoles from '../../common/DeclaracionRoles';

import _ from 'lodash';
// import SelectorModelo from './SelectorModelo'
const FormItem = Form.Item;
const Option = Select.Option;

@compose(
  graphql(getOrganismos, {
    name: 'organismos',
  }),
  graphql(getUsuario)
)
class FormEditarUsuario extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmDirty: false,
      autoCompleteResult: [],
    };
  }

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.onSubmit(values);
      }
    });
  };

  handleConfirmBlur = e => {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  };

  checkConfirm = (rule, value, callback) => {
    const form = this.props.form;
    if (value && this.state.confirmDirty) {
      form.validateFields(['confirm'], { force: true });
    }
    callback();
  };

  crearOpciones(organismo) {
    return (
      <Option key={organismo._id} value={organismo._id}>
        {organismo.nombre}
      </Option>
    );
  }

  render() {
    moment.locale('en');
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    const listaOrganismos = this.props.organismos.getOrganismos;
    if (listaOrganismos) {
      var opcionesOrganismos = _.map(listaOrganismos, this.crearOpciones);
    }

    const usuarioActivo = this.props.data.getUsuario;

    const { datos } = this.props;

    return (
      <div>
        <h1 className="tituloForm">Usuario del Sistema</h1>

        <Form onSubmit={this.handleSubmit} className="formularios">
          <FormItem {...formItemLayout} label={<span>Nombre de usuario</span>}>
            {getFieldDecorator('username', {
              rules: [
                {
                  required: true,
                  message: 'Por favor, ingresar el nombre!',
                  whitespace: true,
                },
              ],
            })(<Input readOnly style={{ width: 500 }} />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Nombre</span>}>
            {getFieldDecorator('nombre', {
              rules: [
                {
                  message: 'Por favor, ingresar el nombre!',
                  whitespace: true,
                },
              ],
            })(<Input style={{ width: 500 }} />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Apellido</span>}>
            {getFieldDecorator('apellido', {
              rules: [
                {
                  message: 'Por favor, ingresar el apellido!',
                  whitespace: true,
                },
              ],
            })(<Input style={{ width: 500 }} />)}
          </FormItem>

          <FormItem {...formItemLayout} label={<span>Activado</span>}>
            {getFieldDecorator('activado')(
              <Checkbox defaultChecked={datos && datos.activado}>
                Activado:{' '}
              </Checkbox>
            )}
          </FormItem>

          {usuarioActivo.rol == DeclaracionRoles.SUPERVISOR && (
            <FormItem
              {...formItemLayout}
              label={<span>Rol del usuario en el sistema</span>}
            >
              {getFieldDecorator('rol', {
                initialValue: 'Administrativo',
                rules: [
                  {
                    required: true,
                    message: 'Por favor, ingresar el rol!',
                    whitespace: true,
                  },
                ],
              })(
                <Select style={{ width: 500 }}>
                  <Option value={DeclaracionRoles.MESA_DE_ENTRADA}>
                    {DeclaracionRoles.MESA_DE_ENTRADA}
                  </Option>
                  <Option value={DeclaracionRoles.DESPACHO}>
                    {DeclaracionRoles.DESPACHO}
                  </Option>
                  <Option value={DeclaracionRoles.FUNCIONARIO}>
                    {DeclaracionRoles.FUNCIONARIO}
                  </Option>
                  <Option value={DeclaracionRoles.OPERADOR}>
                    {DeclaracionRoles.OPERADOR}
                  </Option>
                  <Option value={DeclaracionRoles.ADMINISTRADOR}>
                    {DeclaracionRoles.ADMINISTRADOR}
                  </Option>

                  <Option value={DeclaracionRoles.CONFIGURACION}>
                    {DeclaracionRoles.CONFIGURACION}
                  </Option>
                  <Option value={DeclaracionRoles.SUPERVISOR}>
                    {DeclaracionRoles.SUPERVISOR}
                  </Option>

                  <Option value={DeclaracionRoles.DGJP_DIRECTOR}>
                    {DeclaracionRoles.DGJP_DIRECTOR}
                  </Option>
                  <Option value={DeclaracionRoles.DGJP_EMPLEADO}>
                    {DeclaracionRoles.DGJP_EMPLEADO}
                  </Option>
                  <Option value={DeclaracionRoles.SUELDOS}>
                    {DeclaracionRoles.SUELDOS}
                  </Option>
                  <Option value={DeclaracionRoles.GESTION_HUMANA}>
                    {DeclaracionRoles.GESTION_HUMANA}
                  </Option>
                </Select>
              )}
            </FormItem>
          )}

          <FormItem
            {...formItemLayout}
            label={
              <span>
                Organismo donde trabaja
                <Tooltip title="Seleccione el organismo donde trabaja este usuario">
                  <Icons.QuestionCircleOutlined />
                </Tooltip>
              </span>
            }
          >
            {getFieldDecorator('idOrganismo', {
              rules: [
                { required: true, message: 'Por favor, ingrese el organismo!' },
              ],
            })(
              <Select
                showSearch
                style={{ width: 500 }}
                placeholder="Seleccione un organismo"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {opcionesOrganismos}
              </Select>
            )}
          </FormItem>

          <FormItem {...tailFormItemLayout}>
            <Button type="primary" htmlType="submit">
              Confirmar
            </Button>
            <Button
              type="danger"
              style={{ marginLeft: 10 }}
              onClick={this.props.onAnterior}
            >
              Cancelar
            </Button>
          </FormItem>
        </Form>
      </div>
    );
  }
}

export default Form.create({
  mapPropsToFields(props) {
    // console.log("los datos son....");
    // console.log(props);
    return {
      username: Form.createFormField({
        value: props.datos ? props.datos.username : '',
      }),
      nombre: Form.createFormField({
        value: props.datos ? props.datos.nombre : '',
      }),
      apellido: Form.createFormField({
        value: props.datos ? props.datos.apellido : '',
      }),
      activado: Form.createFormField({
        value: props.datos ? props.datos.activado : false,
        checked: props.datos ? props.datos.activado : false,
      }),
      rol: Form.createFormField({
        value: props.datos.rol,
      }),
      idOrganismo: Form.createFormField({
        value: props.datos.organismo ? props.datos.organismo._id : '',
      }),
    };
  },
})(FormEditarUsuario);
